export default __webpack_public_path__ + "static/media/mature-fund.84baa678.svg";